import { render, staticRenderFns } from "./tnc-th.vue?vue&type=template&id=da865a6e&scoped=true"
import script from "./tnc-th.vue?vue&type=script&lang=js"
export * from "./tnc-th.vue?vue&type=script&lang=js"
import style0 from "./tnc-th.vue?vue&type=style&index=0&id=da865a6e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da865a6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da865a6e')) {
      api.createRecord('da865a6e', component.options)
    } else {
      api.reload('da865a6e', component.options)
    }
    module.hot.accept("./tnc-th.vue?vue&type=template&id=da865a6e&scoped=true", function () {
      api.rerender('da865a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-th.vue"
export default component.exports